import React from 'react';
export function SystemOverview() {
  return <section className="bg-navy px-3 py-4 text-white sm:px-6" data-id="element-145" data-mp="1mhoig5d76tgj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-146" data-mp="18u7pkby93pwu">
        <h2 className="text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-147" data-mp="18tg1dm6zgugl">
          Everything you need. <span className="text-electric" data-id="element-148" data-mp="1hnkopvmwrnrd">One complete visual system.</span>
        </h2>
        <p className="mt-0.5 text-xs font-semibold text-white/80 sm:text-sm" data-id="element-149" data-mp="1hpx6o8so1y4f">
          6 Professional Visual Study Resources In One Organized System
        </p>
        <p className="mt-1.5 font-heading text-sm font-extrabold uppercase leading-tight text-blush sm:text-lg" data-id="element-150" data-mp="pxpy7vnbds14">
          🔬 HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™ — COMPLETE 6-IN-1 VISUAL STUDY SYSTEM
        </p>
        <p className="mt-1.5 text-left text-sm leading-snug text-white/90 sm:text-base" data-id="element-151" data-mp="yvry27vbaemt">
          Histology &amp; Pathology Visual Atlas™ brings histology, tissue
          recognition, normal organ morphology, pathological changes, neoplasia,
          and differential recognition together in one organized visual system.
        </p>
        <p className="mt-1 text-left text-sm leading-snug text-white/90 sm:text-base" data-id="element-152" data-mp="28576lonp488g">
          From foundational tissues and normal organs to inflammation, tissue
          injury, tumor morphology, organ pathology, and microscopy challenges,
          you get structured visual resources designed to help you see what
          matters and understand why.
        </p>
        <p className="mt-2 font-heading text-base font-extrabold tracking-wide text-electric sm:text-2xl" data-id="element-153" data-mp="1kds2bqcczguk">
          SEE → SPOT → COMPARE → RECOGNIZE
        </p>
        <p className="mt-0.5 text-xs font-medium text-white/80 sm:text-sm" data-id="element-154" data-mp="1ud11qypztnob">
          Spend less time searching through scattered references—and more time
          learning what to look for.
        </p>
      </div>
    </section>;
}